.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  color: var(--color-primary);
  cursor: pointer;
  display: inline-flex;
  height: 44px;
  justify-content: center;
  position: relative;
  transition:
    background-color 0.15s,
    transform 0.15s;
  width: 44px;

  &:hover {
    background: var(--color-secondary);
    transform: translateY(-1px);
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px var(--color-primary);
    outline: none;
  }
}

.root-has-fresh-suggestions {
  border-color: var(--color-primary);
}

.dot {
  background: var(--color-primary);
  border: 2px solid var(--color-background);
  border-radius: 50%;
  height: 10px;
  position: absolute;
  right: 6px;
  top: 6px;
  width: 10px;
}
